import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ColoniaDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas : Column[] = [
    {title: "Nombre", cell: x => ({data: x.Nombre })}, 
    {title: "Codigo postal", cell: x => ({data: x.CodigoPostal })}, 
    {title: "ClaveSat", cell: x => ({data: x.ClaveSat })}, 
    
    {title: "Ciudad", cell: x => ({data: x.NombreCiudad })}, 
    {title: "Municipio", cell: x => ({data: x.NombreMunicipio })}, 
    {title: "Estado", cell: x => ({data: x.NombreEstado })}, 
];

/**Obtiene las columnas del grid */
export function columnas(deps: kea.BotonesListaDeps<Entity>) : Column[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [botones, ... columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/DireccionColonia/list/columns.tsx